/** Format pence to GBP display string, e.g. 1500 → "£15.00" */
export function formatGBP(pence) {
    return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
    }).format(pence / 100);
}
/** Calculate age in years from a date string (YYYY-MM-DD) */
export function ageInYears(dateOfBirth) {
    const dob = new Date(dateOfBirth);
    const now = new Date();
    let age = now.getFullYear() - dob.getFullYear();
    const m = now.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && now.getDate() < dob.getDate()))
        age--;
    return age;
}
/** Return true if a UK postcode looks valid (loose check) */
export function isValidUKPostcode(postcode) {
    return /^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/i.test(postcode.trim());
}
/** Parse a Supabase error message into something human-readable */
export function parseAuthError(message) {
    if (message.includes('Invalid login credentials'))
        return 'Incorrect email or password.';
    if (message.includes('Email not confirmed'))
        return 'Please check your email to confirm your account.';
    if (message.includes('User already registered'))
        return 'An account with this email already exists.';
    return message;
}
